import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiX, FiChevronLeft, FiChevronRight, FiDownload, FiMaximize, FiShare2 } = FiIcons;

const ImageLightbox = ({ isOpen, onClose, images, currentIndex, onNavigate }) => {
  if (!isOpen || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[200] bg-accent-navy/98 backdrop-blur-xl flex flex-col"
      >
        {/* Top Bar */}
        <div className="p-6 flex justify-between items-center z-10">
          <div className="text-white/60 text-xs font-black uppercase tracking-widest">
            Memory {currentIndex + 1} of {images.length}
          </div>
          <div className="flex items-center gap-4">
            <button className="p-3 text-white/60 hover:text-white hover:bg-white/10 rounded-full transition-all">
              <SafeIcon icon={FiShare2} className="w-5 h-5" />
            </button>
            <button className="p-3 text-white/60 hover:text-white hover:bg-white/10 rounded-full transition-all">
              <SafeIcon icon={FiDownload} className="w-5 h-5" />
            </button>
            <button 
              onClick={onClose}
              className="p-3 bg-white/10 text-white hover:bg-white/20 rounded-full transition-all border border-white/10"
            >
              <SafeIcon icon={FiX} className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Main Image Area */}
        <div className="flex-grow relative flex items-center justify-center p-4 md:p-12">
          <button 
            onClick={() => onNavigate((currentIndex - 1 + images.length) % images.length)}
            className="absolute left-6 md:left-12 p-4 text-white/40 hover:text-white hover:bg-white/5 rounded-full transition-all z-10"
          >
            <SafeIcon icon={FiChevronLeft} className="w-10 h-10" />
          </button>

          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            className="relative max-w-full max-h-full flex items-center justify-center"
          >
            <img 
              src={currentImage} 
              alt="Memorial Gallery" 
              className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl shadow-black/50"
            />
          </motion.div>

          <button 
            onClick={() => onNavigate((currentIndex + 1) % images.length)}
            className="absolute right-6 md:right-12 p-4 text-white/40 hover:text-white hover:bg-white/5 rounded-full transition-all z-10"
          >
            <SafeIcon icon={FiChevronRight} className="w-10 h-10" />
          </button>
        </div>

        {/* Thumbnails Strip */}
        <div className="p-8 bg-black/20 backdrop-blur-md overflow-x-auto hide-scrollbar flex justify-center gap-3">
          {images.map((img, idx) => (
            <button
              key={idx}
              onClick={() => onNavigate(idx)}
              className={`w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 border-2 transition-all ${idx === currentIndex ? 'border-accent-gold scale-110 shadow-lg' : 'border-transparent opacity-40 hover:opacity-100'}`}
            >
              <img src={img} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ImageLightbox;